<template>
  <div class="addr-edit-component">
    <Row>
      <Col span="8" class="col-label">{{$t('addr.label_user')}}</Col>
      <Col span="16">
        <Input class="field-value" style="width: 15em;"
               maxlength="15"
               v-model="mAddr.receive_name" ref="rec_name"
               :placeholder="$t('addr.ph_user')"/>
      </Col>
    </Row>

    <Row>
      <Col span="8" class="col-label">{{$t('page.login.state_code')}}</Col>
      <Col span="16">
        <SCodeSelect class="field-value"
                     v-model="mAddr.state_code" width="15em"
                     :placeholder="$t('page.login.ph_statecode')"/>
      </Col>
    </Row>

    <Row>
      <Col span="8" class="col-label">{{$t('addr.label_tel')}}</Col>
      <Col span="16">
        <Input class="field-value" style="width: 15em;"
               maxlength="15"
               v-model="mAddr.receive_tel" ref="rec_tel"
               :placeholder="$t('addr.ph_tel')"/>
      </Col>
    </Row>

    <Row>
      <Col span="8" class="col-label">{{$t('addr.label_area')}}</Col>
      <Col span="16">
        <Input v-model="mAddr.area_info" readonly class="field-value"
               :placeholder="$t('addr.ph_area_sel')"
               @on-focus="mAreaSelect=true"/>
        <!-- 区域选择 -->
        <AreaSelect v-if="mAreaSelect" v-model="mAddr.area_ids" :max-len="3"
                    @on-change="(val)=>{mAddr.area_info=val}"
                    :header="$t('addr.ph_area_first')"/>
      </Col>
    </Row>
    <Row>
      <Col span="8" class="col-label">{{$t('addr.postcode')}}</Col>
      <Col span="16">
        <Input v-model="mAddr.postcode" readonly/>
      </Col>
    </Row>
    <Row>
      <Col span="8" class="col-label">{{$t('addr.label_address')}}</Col>
      <Col span="16">
        <Input class="field-value" maxlength="64"
               v-model="mAddr.address" ref="rec_addr"
               :placeholder="$t('addr.ph_address')"/>
      </Col>
    </Row>

    <Row v-if="!okMode">
      <Col span="8" class="col-label">{{$t('addr.label_addr_def')}}</Col>
      <Col span="16">
        <i-switch v-model="mAddr.is_default" :disabled="mEmpty.is_default"
                  style="margin-top: 8px;"/>
      </Col>
    </Row>

    <div style="text-align: center;margin-top: 20px;">
      <Button v-if="okMode" type="primary"
              style="width: 40%;"
              @click="onOK">{{$t('common.btn_ok')}}</Button>
      <Button v-else type="primary" :loading="busy"
              style="width: 40%;"
              @click="onSave">{{$t('common.btn_save')}}</Button>
<!--      <Button v-if="deletable && mAddr.id>0" :loading="busy" type="error"-->
<!--              style="width: 40%;margin-left: 10%;"-->
<!--              @click="onDelete">{{$t('common.btn_del')}}</Button>-->
    </div>
  </div>
</template>

<script>
    import { httpPost, httpDelete } from '@/api/http';
    import AreaSelect from '@/components/AreaSelect';
    import SCodeSelect from '@/components/SCodeSelect';

    export default {
        name: 'AddrEdit',
        components: {
            AreaSelect,
            SCodeSelect
        },
        props: {
            addr: Object,
            def: Boolean,
            deletable: Boolean,
            okMode: Boolean
        },
        data () {
            return {
                busy: false,
                mEmpty: {
                    id: 0,
                    receive_name: '',
                    state_code: null,
                    receive_tel: '',
                    area_info: '',
                    area_ids: [],
                    postcode: '',
                    address: '',
                    is_default: false
                },
                mAddr: null,
                postcode: null,

                mAreaSelect: false
            }
        },
        watch: {
            addr (val) {
                this.setAddress(val);
            },
            def (val) {
                this.mEmpty.is_default = val;
            },
            'mAddr.area_ids': {
                handler (val) {
                    if (val?.length > 0) {
                        for (let i = 0; i < val.length; i++) {
                            if (this.$store.state.postcode.hasOwnProperty(val[i])) {
                                this.mAddr.postcode = this.$store.state.postcode[val[i]];
                                break;
                            }
                        }
                    }
                },
                deep: true,
                immediate: true
            }

        },
        methods: {
            setAddress (addr) {
                if (addr) {
                    this.mAddr = { ...addr };
                } else {
                    this.mAddr = { ...this.mEmpty };
                    const info = this.$store.state.local_info;
                    if (info) {
                        this.mAddr.state_code = info.code;
                        this.mAddr.receive_tel = info.account;
                    }
                }
                /* if (this.def) {
                    this.mAddr.is_default = true;
                } */
            },
            verify () {
                this.mAddr.receive_name = this.mAddr.receive_name.trim();
                if (this.mAddr.receive_name.length === 0) {
                    this.$Message.error(this.$t('addr.tip_invalid_name'));
                    this.$refs.rec_name.focus();
                    return false;
                }
                if (this.mAddr.state_code.length < 2) {
                    this.$Message.error(this.$t('addr.tip_invalid_state_code'));
                    return false;
                }
                this.mAddr.receive_tel = this.mAddr.receive_tel.trim();
                if (this.mAddr.receive_tel.length < 6) {
                    this.$Message.error(this.$t('addr.tip_invalid_tel'));
                    this.$refs.rec_tel.focus();
                    return false;
                }
                this.mAddr.area_info = this.mAddr.area_info.trim();
                if (this.mAddr.area_info.length < 2 || !this.mAddr.area_ids || this.mAddr.area_ids.length === 0) {
                    this.$Message.error(this.$t('addr.tip_invalid_area'));
                    return false;
                }

                this.mAddr.address = this.mAddr.address.trim();
                if (this.mAddr.address.length === 0) {
                    this.$Message.error(this.$t('addr.tip_invalid_addr'));
                    this.$refs.rec_addr.focus();
                    return false;
                }
                return true;
            },
            onOK () {
                if (!this.verify()) {
                    return;
                }
                this.$emit('on-ok', this.mAddr);
            },
            onSave () {
                if (this.busy) {
                    return;
                }
                // 检查数据
                if (!this.verify()) {
                    return;
                }
                let url = '/v1/user/address';
                if (this.mAddr.id > 0) {
                    url += '/' + this.mAddr.id;
                }
                // 检查是否有修改
                if (this.addr && this.addr.area_info === this.mAddr.area_info &&
                    this.addr.address === this.mAddr.address &&
                    this.addr.receive_name === this.mAddr.receive_name &&
                    this.addr.receive_tel === this.mAddr.receive_tel &&
                    this.addr.postcode === this.mAddr.postcode) {
                    if (this.addr.is_default === this.mAddr.is_default) {
                        this.$emit('on-save', null);
                        return;
                    }

                    // 只有default变化时调用单独的接口
                    url += '/default';
                    this.busy = true;
                    httpPost(url).then(() => {
                        this.$emit('on-save', this.mAddr);
                    }).catch(() => {
                    }).finally(() => {
                        this.busy = false;
                    });
                    return;
                }
                this.busy = true;
                httpPost(url, this.mAddr).then((res) => {
                    this.$emit('on-save', res);
                }).catch(() => {
                }).finally(() => {
                    this.busy = false;
                });
            },
            onDelete () {
                if (this.mAddr.id <= 0) {
                    return;
                }
                this.$Modal.confirm({
                    title: this.$t('common.alert_title'),
                    content: this.$t('common.delete_confirm'),
                    onOk: () => {
                        this.busy = true;
                        httpDelete('/v1/user/address/' + this.mAddr.id).then(() => {
                            this.$emit('on-delete', this.mAddr.id);
                        }).catch(() => {
                        }).finally(() => {
                            this.busy = false;
                        });
                    }
                });
            }
        },
        mounted () {
            this.setAddress(this.addr);
        },
        created () {
            this.mAddr = this.mEmpty
        },
        beforeDestroy () {
            if (this.cancel) {
                this.cancel();
                this.cancel = null;
            }
        }
    }
</script>

<style lang="scss">
  .addr-edit-component {
    padding-left: 5px;
    padding-right: 5px;
    .ivu-row {
      margin-bottom: 10px;
    }
    .col-label {
      padding-top: 10px;
      padding-right: 5px;
      text-align: right;
    }
    .field-value {
      max-width: 100%;
    }
  }
</style>
